import React from 'react';
import HomeWrap from '../../views/home/HomeWrap';

const HomeContainer = () => {
  return <HomeWrap />;
};

export default HomeContainer;
